/* eslint-disable */
import { useState, useRef, useEffect } from 'react';
import { makeStyles, Popover, Collapse, TextField, InputAdornment } from '@material-ui/core';
import PropTypes from 'prop-types';
import RoundedButton from 'components/Shared/RoundedButton';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { ReactComponent as NoteIcon } from '../../../assets/icons/note.svg';
import { ASSESSMENT_FILTER_LIST } from '../../Assessments/constants';
import assessmentsPlaceholderImage from '../../../assets/placeholders/orders.svg';
import TablePlaceholder from '../TablePlaceholder';
import Loader from '../Loader';
import { getTransitionWithVariable } from '../../../redux_store';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import ViewListIcon from '@material-ui/icons/ViewList';
import SearchIcon from '@material-ui/icons/Search';
import { sortBySearchRelevance } from './searchSort';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    flex: 1,
    overflow: 'hidden',
  },
  contentContainer: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
  },
  categoriesContainer: {
    marginBottom: theme.spacing(3),
  },
  categorySection: {
    marginBottom: theme.spacing(2),
    backgroundColor: 'white',
    borderRadius: 16,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
  },
  categoryHeader: {
    padding: theme.spacing(2, 3),
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#e9ecef',
    },
  },
  categoryTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#2d3748',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  categoryCount: {
    backgroundColor: '#5B65DC',
    color: 'white',
    fontSize: 12,
    fontWeight: 600,
    padding: '4px 8px',
    borderRadius: 12,
    minWidth: 20,
    textAlign: 'center',
  },
  expandIcon: {
    transition: 'transform 0.3s ease',
    color: '#5B65DC',
  },
  expandIconRotated: {
    transform: 'rotate(180deg)',
  },
  assessmentGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3, 3, 3),
  },
  assessmentCard: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: theme.spacing(3),
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.3s ease',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1.5),
  },
  cardIcon: {
    width: 48,
    height: 48,
    padding: 12,
    backgroundColor: '#f0f2ff',
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      width: 24,
      height: 24,
      fill: '#5B65DC',
    },
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#2d3748',
    lineHeight: 1.4,
    marginBottom: theme.spacing(0.5),
    flex: 1,
  },
  cardDescription: {
    fontSize: 14,
    color: '#718096',
    lineHeight: 1.5,
    marginBottom: theme.spacing(2),
    flex: 1,
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 'auto',
  },
  selectButton: {
    backgroundColor: '#5B65DC',
    color: 'white',
    borderRadius: 8,
    padding: '8px 20px',
    fontSize: 13,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    border: 'none',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#0088cc',
      transform: 'translateY(-1px)',
    },
    '&:disabled': {
      backgroundColor: '#e2e8f0',
      color: '#a0aec0',
    },
  },
  readMoreButton: {
    background: 'none',
    border: 'none',
    color: '#5B65DC',
    fontSize: 13,
    fontWeight: 500,
    cursor: 'pointer',
    padding: 0,
    textDecoration: 'underline',
    '&:hover': {
      color: '#0088cc',
    },
  },
  controlsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    backgroundColor: 'white',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    gap: theme.spacing(2),
    flexShrink: 0,
  },
  controlsLeft: {
    fontSize: 14,
    color: '#718096',
  },
  controlsRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  expandAllButton: {
    background: 'none',
    border: 'none',
    color: '#5B65DC',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    padding: '6px 12px',
    borderRadius: 6,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#e6f7ff',
    },
  },
  actionsContainer: {
    padding: theme.spacing(3, 0, 0, 0),
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexShrink: 0,
    marginTop: 'auto',
  },
  cancelButton: {
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 300,
    backgroundColor: 'white',
    borderRadius: 16,
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  popover: {
    '& .MuiPopover-paper': {
      minWidth: 350,
      maxWidth: 500,
    },
  },
  popoverText: {
    padding: theme.spacing(3),
    fontSize: 14,
    lineHeight: 1.6,
    color: '#2d3748',
    maxHeight: 200,
    overflow: 'auto',
    minWidth: 300,
  },
  paper: {
    borderRadius: 16,
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
    border: '1px solid rgba(0, 168, 255, 0.1)',
    background: 'linear-gradient(135deg, #ffffff 0%, #fafbff 100%)',
  },
  loaderStyle: {
    margin: '40px 0',
  },
  viewToggle: {
    display: 'flex',
    backgroundColor: '#f0f2ff',
    borderRadius: 8,
    padding: 2,
    gap: 2,
  },
  viewToggleButton: {
    background: 'none',
    border: 'none',
    padding: '6px 12px',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    color: '#718096',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
  viewToggleButtonActive: {
    backgroundColor: 'white',
    color: '#5B65DC',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  listView: {
    backgroundColor: 'white',
    borderRadius: 16,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
  },
  listItem: {
    padding: theme.spacing(2, 1),
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  listItemIcon: {
    width: 40,
    height: 40,
    padding: 8,
    backgroundColor: '#f0f2ff',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      width: 20,
      height: 20,
      fill: '#5B65DC',
    },
  },
  listItemContent: {
    flex: 1,
    minWidth: 0,
  },
  listItemTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#2d3748',
    marginBottom: 4,
  },
  listItemDescription: {
    fontSize: 14,
    color: '#718096',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  listItemActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  listReadMoreButton: {
    background: 'none',
    border: 'none',
    color: '#5B65DC',
    fontSize: 12,
    fontWeight: 500,
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: 4,
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: '#e6f7ff',
    },
  },
  listSelectButton: {
    backgroundColor: '#5B65DC',
    color: 'white',
    borderRadius: 6,
    padding: '6px 16px',
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    border: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#0088cc',
    },
    '&:disabled': {
      backgroundColor: '#e2e8f0',
      color: '#a0aec0',
    },
  },
  searchField: {
    flex: 1,
    maxWidth: 300,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: 'white',
      height: 36,
      fontSize: 14,
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.1)',
      },
      '&:hover fieldset': {
        borderColor: '#5B65DC',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#5B65DC',
        borderWidth: 2,
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 14px',
    },
    '& .MuiInputAdornment-root': {
      marginRight: 0,
    },
  },
  highlightedText: {
    backgroundColor: '#ffeb3b',
    color: '#000',
    fontWeight: 600,
    padding: '0 2px',
    borderRadius: 2,
  },
}));

const FilteredItemList = ({
                            items,
                            handleClose,
                            selectItem,
                            activeItem,
                            loading,
                            iconList,
                            notFoundTitle,
                            itemsName,
                          }) => {
  const classes = useStyles();
  const { en: { btn, placeholders } } = useSelector((state) => state.i18n);
  const { disabledFeatures } = useSelector((state) => state.appSettings);
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverText, setPopoverText] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState(new Set(['all']));
  const [truncatedDescriptions, setTruncatedDescriptions] = useState(new Set());
  const [viewMode, setViewMode] = useState(1); // 0 = grid, 1 = list
  const [searchQuery, setSearchQuery] = useState('');
  const contentContainerRef = useRef(null);
  const searchInputRef = useRef(null);
  const openPopover = Boolean(anchorEl);
  const popoverId = openPopover ? 'simple-popover' : undefined;

  // Auto-focus search input on mount
  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  // Function to highlight matching text
  const highlightText = (text, query) => {
    if (!query || !text) return text;

    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) => {
      if (part.toLowerCase() === query.toLowerCase()) {
        return <span key={index} className={classes.highlightedText}>{part}</span>;
      }
      return part;
    });
  };

  const handleClick = (event, text) => {
    setAnchorEl(event.currentTarget);
    setPopoverText(text);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const checkTextTruncation = (element, title) => {
    if (element) {
      const isOverflowing = element.scrollHeight > element.clientHeight;
      setTruncatedDescriptions(prev => {
        const hasTitle = prev.has(title);
        if (isOverflowing && !hasTitle) {
          const newSet = new Set(prev);
          newSet.add(title);
          return newSet;
        } else if (!isOverflowing && hasTitle) {
          const newSet = new Set(prev);
          newSet.delete(title);
          return newSet;
        }
        return prev;
      });
    }
  };

  const toggleCategory = (categoryId) => {
    const newExpanded = new Set(expandedCategories);
    const wasExpanded = newExpanded.has(categoryId);

    if (wasExpanded) {
      newExpanded.delete(categoryId);
    } else {
      newExpanded.add(categoryId);
      // Scroll to the category header when expanding
      setTimeout(() => {
        const categoryElement = document.getElementById(`category-${categoryId}`);
        if (categoryElement && contentContainerRef.current) {
          const containerRect = contentContainerRef.current.getBoundingClientRect();
          const elementRect = categoryElement.getBoundingClientRect();
          const scrollTop = contentContainerRef.current.scrollTop;
          const targetScrollTop = scrollTop + (elementRect.top - containerRect.top) - 20; // 20px offset from top

          contentContainerRef.current.scrollTo({
            top: Math.max(0, targetScrollTop),
            behavior: 'smooth',
          });
        }
      }, 300); // Increased delay to allow animation to start
    }

    setExpandedCategories(newExpanded);
  };


  const filterItemsBySearch = (itemsList) => {
    if (!searchQuery.trim()) {
      return itemsList;
    }

    const query = searchQuery.toLowerCase().trim();
    return itemsList.filter(item =>
      item.title.toLowerCase().includes(query) ||
      (item.description && item.description.toLowerCase().includes(query)),
    );
  };

  const groupItemsByCategory = () => {
    const filteredItems = items.filter(item =>
      item.disabledId == null || !disabledFeatures.includes(item.disabledId),
    );

    // Apply search filter
    const searchFilteredItems = filterItemsBySearch(filteredItems);

    // While searching, surface title matches above description-only matches
    // within each category (same rule as the flat list view). With no query
    // the category order is left untouched.
    const orderForSearch = (list) =>
      searchQuery.trim() ? sortBySearchRelevance(list, searchQuery) : list;

    const grouped = {};

    ASSESSMENT_FILTER_LIST.forEach(({ id, title }) => {
      if (id === 'all') return;
      grouped[id] = {
        title,
        items: orderForSearch(searchFilteredItems.filter(item =>
          item.categories && item.categories.includes(id),
        )),
      };
    });

    // Add "Other" category for items without specific categories
    const categorizedItemIds = new Set();
    Object.values(grouped).forEach(group => {
      group.items.forEach(item => categorizedItemIds.add(item.title));
    });

    const otherItems = orderForSearch(
      searchFilteredItems.filter(item => !categorizedItemIds.has(item.title)),
    );
    if (otherItems.length > 0) {
      grouped['other'] = {
        title: 'Other',
        items: otherItems,
      };
    }

    return grouped;
  };

  const handleExpandAll = () => {
    const allCategories = Object.keys(groupItemsByCategory());
    setExpandedCategories(new Set(allCategories));
  };

  const handleCollapseAll = () => {
    setExpandedCategories(new Set());
  };

  const handleViewModeChange = (event, newValue) => {
    setViewMode(newValue);
  };

  const getAllFilteredItems = () => {
    const filteredItems = items
      .filter(item =>
        item.disabledId == null || !disabledFeatures.includes(item.disabledId),
      );

    // Apply search filter
    const searchFilteredItems = filterItemsBySearch(filteredItems);

    return sortBySearchRelevance(searchFilteredItems, searchQuery);
  };

  const grouped = groupItemsByCategory();
  const allCategories = Object.keys(grouped);
  const isAllExpanded = allCategories.every(cat => expandedCategories.has(cat));
  const isAllCollapsed = allCategories.every(cat => !expandedCategories.has(cat));

  return (
    <div className={classes.container}>
      <Popover
        classes={{
          root: classes.popover,
          paper: classes.paper,
        }}
        id={popoverId}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className={classes.popoverText}>{popoverText}</div>
      </Popover>


      {!items.length && loading && (
        <Loader fullHeight className={classes.loaderStyle} />
      )}

      {!items.length && !loading && (
        <div className={classes.emptyState}>
          <TablePlaceholder
            image={assessmentsPlaceholderImage}
            itemsNotFoundText={getTransitionWithVariable(placeholders.noItemsFound, {
              item: notFoundTitle,
            })}
            message={getTransitionWithVariable(placeholders.noFilteredItemsFound, {
              item: notFoundTitle,
            })}
          />
        </div>
      )}

      {!!items.length && (
        <>
          <div className={classes.controlsContainer}>
            <TextField
              inputRef={searchInputRef}
              className={classes.searchField}
              variant='outlined'
              placeholder={`Search ${itemsName}s...`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon style={{ fontSize: 20, color: '#718096' }} />
                  </InputAdornment>
                ),
              }}
            />

            <div className={classes.controlsLeft} style={{ marginLeft: 0 }}>
              {viewMode === 0
                ? `${getAllFilteredItems().length} ${itemsName}s in ${allCategories.length} categories`
                : `${getAllFilteredItems().length} ${itemsName}s`
              }
            </div>

            <div className={classes.controlsRight} style={{ marginLeft: 'auto' }}>
              {viewMode === 0 && (
                <button
                  className={classes.expandAllButton}
                  onClick={isAllExpanded ? handleCollapseAll : handleExpandAll}
                >
                  {isAllExpanded ? 'Collapse All' : 'Expand All'}
                </button>
              )}
              <div className={classes.viewToggle}>
                <button
                  className={cx(
                    classes.viewToggleButton,
                    viewMode === 1 && classes.viewToggleButtonActive,
                  )}
                  onClick={() => setViewMode(1)}
                >
                  <ViewListIcon style={{ fontSize: 16 }} />
                  List
                </button>
                <button
                  className={cx(
                    classes.viewToggleButton,
                    viewMode === 0 && classes.viewToggleButtonActive,
                  )}
                  onClick={() => setViewMode(0)}
                >
                  <ViewModuleIcon style={{ fontSize: 16 }} />
                  Grid
                </button>
              </div>
            </div>
          </div>

          <div className={classes.contentContainer} ref={contentContainerRef}>
            {getAllFilteredItems().length === 0 && searchQuery ? (
              <div className={classes.emptyState}>
                <TablePlaceholder
                  image={assessmentsPlaceholderImage}
                  itemsNotFoundText='No results found'
                  message={`No ${itemsName}s match "${searchQuery}"`}
                />
              </div>
            ) : viewMode === 0 ? (
              <div className={classes.categoriesContainer}>
                {Object.entries(grouped).map(([categoryId, {
                  title: categoryTitle,
                  items: categoryItems,
                }]) => {
                  if (categoryItems.length === 0) return null;

                  const isExpanded = expandedCategories.has(categoryId);

                  return (
                    <div key={categoryId} className={classes.categorySection}
                         id={`category-${categoryId}`}>
                      <div
                        className={classes.categoryHeader}
                        onClick={() => toggleCategory(categoryId)}
                      >
                        <div className={classes.categoryTitle}>
                          <span>{categoryTitle}</span>
                          <span className={classes.categoryCount}>{categoryItems.length}</span>
                        </div>
                        <ExpandMoreIcon
                          className={cx(
                            classes.expandIcon,
                            isExpanded && classes.expandIconRotated,
                          )}
                        />
                      </div>
                      <Collapse in={isExpanded}>
                        <div className={classes.assessmentGrid}>
                          {categoryItems.map((itemProps) => {
                            const { title, description, type } = itemProps;

                            const isCustomIcon = !!type && !!iconList && iconList.hasOwnProperty(type);
                            const icon = isCustomIcon ? iconList[type] : <NoteIcon />;

                            const isLoading = activeItem === title && loading;
                            const isDisabled = activeItem !== title && loading;

                            return (
                              <div key={title} className={classes.assessmentCard}>
                                <div className={classes.cardHeader}>
                                  <div className={classes.cardIcon}>
                                    {icon}
                                  </div>
                                  <div>
                                    <div className={classes.cardTitle}>
                                      {highlightText(title, searchQuery)}
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={classes.cardDescription}
                                  ref={(el) => checkTextTruncation(el, title)}
                                >
                                  {highlightText(description, searchQuery)}
                                </div>

                                <div className={classes.cardActions}>
                                  {truncatedDescriptions.has(title) ? (
                                    <button
                                      className={classes.readMoreButton}
                                      onClick={(event) => handleClick(event, description)}
                                    >
                                      {btn.readMore}
                                    </button>
                                  ) : (
                                    <div></div>
                                  )}

                                  <button
                                    className={classes.selectButton}
                                    onClick={() => selectItem(itemProps)}
                                    disabled={isDisabled}
                                  >
                                    {isLoading ? 'Loading...' : btn.select}
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Collapse>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className={classes.listView}>
                {getAllFilteredItems().map((itemProps) => {
                  const { title, description, type } = itemProps;

                  const isCustomIcon = !!type && !!iconList && iconList.hasOwnProperty(type);
                  const icon = isCustomIcon ? iconList[type] : <NoteIcon />;

                  const isLoading = activeItem === title && loading;
                  const isDisabled = activeItem !== title && loading;

                  return (
                    <div key={title} className={classes.listItem}>
                      <div className={classes.listItemIcon}>
                        {icon}
                      </div>

                      <div className={classes.listItemContent}>
                        <div className={classes.listItemTitle}>
                          {highlightText(title, searchQuery)}
                        </div>
                        <div
                          className={classes.listItemDescription}
                          ref={(el) => checkTextTruncation(el, `list-${title}`)}
                        >
                          {highlightText(description, searchQuery)}
                        </div>
                      </div>

                      <div className={classes.listItemActions}>
                        {truncatedDescriptions.has(`list-${title}`) && (
                          <button
                            className={classes.listReadMoreButton}
                            onClick={(event) => handleClick(event, description)}
                          >
                            {btn.readMore}
                          </button>
                        )}

                        <button
                          className={classes.listSelectButton}
                          onClick={() => selectItem(itemProps)}
                          disabled={isDisabled}
                        >
                          {isLoading ? 'Loading...' : btn.select}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </>
      )}

      <div className={classes.actionsContainer}>
        <RoundedButton
          variant='outlined'
          color='primary'
          size='medium'
          onClick={handleClose}
          className={classes.cancelButton}
        >
          {btn.cancel}
        </RoundedButton>
      </div>
    </div>
  );
};

FilteredItemList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleClose: PropTypes.func.isRequired,
  selectItem: PropTypes.func.isRequired,
  activeItem: PropTypes.object.isRequired,
  iconList: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  dataList: PropTypes.arrayOf(PropTypes.object).isRequired,
  setFilteredDataList: PropTypes.func.isRequired,
  notFoundTitle: PropTypes.func.isRequired,
};

FilteredItemList.defaultProps = {
  iconList: {},
};

export default FilteredItemList;
